import CheckBoxInput from 'components/elements/inputs/check-box-input';
import {
  isCheckedCheckboxTable,
  isIndeterminateCheckboxTable,
} from 'components/elements/table/utils';
import { useFormContext, useWatch } from 'react-hook-form';

import { HotelScheduleFormType } from './hotel-schedule-form-type';

const name = 'hotelSchedules' as const;

export default function HotelScheduleCheckboxHeader() {
  const { control, setValue } = useFormContext<HotelScheduleFormType>();
  const hotelSchedules = useWatch({
    name,
    control,
  });
  const isIndeterminate = isIndeterminateCheckboxTable({
    type: 'state',
    data: hotelSchedules,
    isCheck(data) {
      return data.isCheck;
    },
  });

  const checked = isCheckedCheckboxTable({
    type: 'state',
    data: hotelSchedules,
    isCheck(data) {
      return data.isCheck;
    },
  });

  return (
    <CheckBoxInput
      checked={checked}
      isIndeterminate={isIndeterminate}
      onChange={(e) => {
        const checked = e.currentTarget.checked;
        const schedules = hotelSchedules.map((schedule) => {
          return {
            ...schedule,
            isCheck: checked,
          };
        });
        setValue(name, schedules, {
          shouldTouch: true,
          shouldValidate: true,
        });
      }}
    />
  );
}
